var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVueCarte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.7 27.8",
    style: {
      enableBackground: "new 0 0 23.7 27.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M11.8,27.7c-0.3,0-0.5-0.1-0.7-0.3c-1.1-1-10.9-9.5-10.9-15.6c0-6.4,5.2-11.7,11.7-11.7 c6.4,0,11.7,5.2,11.7,11.7c0,6.2-9.8,14.7-10.9,15.6C12.3,27.6,12,27.7,11.8,27.7L11.8,27.7z M11.8,2.4c-5.2,0-9.4,4.2-9.4,9.4 c0,4,6.2,10.4,9.4,13.3c3.2-2.9,9.4-9.3,9.4-13.3C21.2,6.6,16.9,2.4,11.8,2.4L11.8,2.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M11.8,17.4c-3.1,0-5.7-2.5-5.7-5.7c0-3.1,2.6-5.7,5.7-5.7c3.1,0,5.7,2.5,5.7,5.7 C17.5,14.9,14.9,17.4,11.8,17.4L11.8,17.4z M11.8,8.4c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4S13.7,8.4,11.8,8.4 L11.8,8.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueCarte);
export default __webpack_public_path__ + "static/media/Vue_Carte.ba6c1ed8.svg";
export { ForwardRef as ReactComponent };